var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cgs-grid"},_vm._l((_vm.options),function(item){return _c('label',{key:item[_vm.itemKey],staticClass:"cgs-item"},[_c('input',{staticClass:"cgs-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked(item)},on:{"change":function($event){return _vm.toggle(item)}}}),_vm._v(" "+_vm._s(item[_vm.itemLabel])+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }